import { memo, useEffect, useState } from "react";
import { Avatar, Chip, ChipProps } from "@mui/material";
import Corretora from "../../../models/corretora";
import { getDoc } from "firebase/firestore";
import CorretoraDb from "../../../db/corretoraDb";
import { IconBuildingBank } from "@tabler/icons-react";

type Props = {
  codigoCorretora?: string;
} & ChipProps;

export default memo(
  function ChipCorretoraInterno({
    codigoCorretora,
    size = "small",
    ...rest
  }: Props) {
    const [corretora, setCorretora] = useState<Corretora>();

    useEffect(() => {
      if (codigoCorretora) {
        getDoc(new CorretoraDb().doc({ corretoraId: codigoCorretora })).then(
          (doc) => setCorretora(doc.data())
        );
      }
    }, [codigoCorretora]);

    return (
      <Chip
        avatar={
          <Avatar src={corretora?.avatar}>
            <IconBuildingBank />
          </Avatar>
        }
        size={size}
        sx={{
          bgcolor: corretora?.cor,
          "& .MuiChip-avatar": { bgcolor: "transparent" },
        }}
        color="primary"
        label={corretora?.apelido ?? "Sua Corretora"}
        {...rest}
      />
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.codigoCorretora === nextProps.codigoCorretora &&
      prevProps.size === nextProps.size
    );
  }
);
